var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Checkbox, Flex, Heading, Spacer, Text, Textarea, ToastErrorBox, ToastSuccessBox, useToast, } from 'shared/components';
import React from 'react';
import { useReferToSUD } from 'shared/hooks/useReferToSUD';
import { useQueryClient } from 'react-query';
import { Close } from 'shared/assets/icons';
export var ReferToSUDModal = function (_a) {
    var disclosure = _a.disclosure, scheduleWithSUDModalDisclosure = _a.scheduleWithSUDModalDisclosure, sudPowerPanelDisclosure = _a.sudPowerPanelDisclosure, memberFirstName = _a.memberFirstName, memberFullName = _a.memberFullName, memberId = _a.memberId;
    var cancelRef = React.useRef(null);
    var toast = useToast();
    var _b = React.useState(''), referrerNote = _b[0], setReferrerNote = _b[1];
    var _c = React.useState(false), showScheduleModal = _c[0], setShowScheduleModal = _c[1];
    var queryClient = useQueryClient();
    var _d = useReferToSUD({
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toast({
                            status: 'success',
                            position: 'top',
                            duration: 3000,
                            isClosable: true,
                            render: function (_a) {
                                var onClose = _a.onClose;
                                return (_jsx(ToastSuccessBox, { "data-testid": 'toastSuccessBox', onClose: onClose, title: "".concat(memberFirstName, " successfully referred to the SUD program!"), message: 'A Care Navigator will be reaching out to them shortly.', variant: 'success', progressDuration: 3000, toastBoxProps: {
                                        height: 'fit-content',
                                    } }));
                            },
                        });
                        disclosure.onClose();
                        sudPowerPanelDisclosure.close();
                        return [4 /*yield*/, queryClient.invalidateQueries(['sud_program', memberId])];
                    case 1:
                        _a.sent();
                        if (showScheduleModal) {
                            scheduleWithSUDModalDisclosure.onOpen();
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function (error) {
            var _loop_1 = function (e) {
                toast({
                    position: 'top',
                    status: 'error',
                    duration: 15000,
                    render: function (_a) {
                        var onClose = _a.onClose;
                        return (_jsx(ToastErrorBox, { onClose: onClose, title: 'Something went wrong', message: e.message }));
                    },
                });
            };
            for (var _i = 0, _a = error.response.errors; _i < _a.length; _i++) {
                var e = _a[_i];
                _loop_1(e);
            }
        },
    }), referToSUD = _d.mutate, isLoadingReferToSUD = _d.isLoading;
    return (_jsx(_Fragment, { children: _jsxs(AlertDialog, __assign({ size: '3xl', motionPreset: 'slideInBottom', leastDestructiveRef: cancelRef, isOpen: disclosure.isOpen, onClose: disclosure.onClose, isCentered: true }, { children: [_jsx(AlertDialogOverlay, {}), _jsxs(AlertDialogContent, __assign({ px: 5, borderRadius: 4, py: 5 }, { children: [_jsx(AlertDialogHeader, __assign({ px: 0, py: 3 }, { children: _jsxs(Flex, __assign({ align: "center" }, { children: [_jsxs(Heading, __assign({ size: "h2" }, { children: ["Refer ", memberFullName, " to SUD Program"] })), _jsx(Spacer, {}), _jsx(AlertDialogCloseButton, __assign({ color: "green.500", boxSize: 4, position: "inherit" }, { children: _jsx(Close, {}) }))] })) })), _jsxs(AlertDialogBody, __assign({ p: 0 }, { children: [_jsx(Text, __assign({ fontSize: 18 }, { children: "Referring the client to the Substance Use Disorder (SUD) program will alert the SUD team to conduct outreach. A SUD CN will contact the client to provide support and connect them to care." })), _jsx(Text, __assign({ mt: 4, mb: 2, fontWeight: 600, fontSize: 18 }, { children: "Add additional information for SUD Care Navigation." })), _jsx(Textarea, { onChange: function (e) {
                                        setReferrerNote(e.target.value);
                                    } }), _jsx(Text, __assign({ mt: 4, mb: 2, fontWeight: 600, fontSize: 18 }, { children: "Schedule a SUD CN enrollment meeting for the client?" })), _jsx(Checkbox, __assign({ w: '100%', onChange: function (e) {
                                        setShowScheduleModal(e.target.checked);
                                    } }, { children: "Yes, schedule a meeting after submitting the referral" }))] })), _jsxs(AlertDialogFooter, __assign({ px: 0, justifyContent: 'space-between', gap: 3 }, { children: [_jsx(Button, __assign({ isFullWidth: true, size: 'lg', borderRadius: '3px', variant: 'secondary', ref: cancelRef, onClick: disclosure.onClose }, { children: "Cancel" })), _jsx(Button, __assign({ isFullWidth: true, borderRadius: '3px', size: 'lg', isLoading: isLoadingReferToSUD, onClick: function () {
                                        referToSUD({
                                            member_id: memberId,
                                            referrer_note: referrerNote,
                                        });
                                    } }, { children: "Refer Client to SUD Program" }))] }))] }))] })) }));
};
